import { render, staticRenderFns } from "./CommentBar.vue?vue&type=template&id=6f25a196&scoped=true"
import script from "./CommentBar.vue?vue&type=script&lang=js"
export * from "./CommentBar.vue?vue&type=script&lang=js"
import style0 from "./CommentBar.vue?vue&type=style&index=0&id=6f25a196&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f25a196",
  null
  
)

export default component.exports